module.exports = __webpack_public_path__ + "img/codesandbox.0a83e818.svg";